import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WebSocketSessionzi1ianvyj32u as WebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/DefaultWebSocketSession.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultClientWebSocketSessionClass;
function DefaultClientWebSocketSession() {
  if (DefaultClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, delegate) {
        this.g5t_1 = delegate;
        this.h5t_1 = call;
      }
      *r5b(frame, $completion) {
        yield* this.g5t_1.r5b(frame, $completion);
        return Unit_instance;
      }
      *k4k($completion) {
        yield* this.g5t_1.k4k($completion);
        return Unit_instance;
      }
      n5b(_set____db54di) {
        this.g5t_1.n5b(_set____db54di);
      }
      o5b() {
        return this.g5t_1.o5b();
      }
      p5b() {
        return this.g5t_1.p5b();
      }
      q5b() {
        return this.g5t_1.q5b();
      }
      bw() {
        return this.g5t_1.bw();
      }
      m5b(negotiatedExtensions) {
        this.g5t_1.m5b(negotiatedExtensions);
      }
      l5b() {
        return this.g5t_1.l5b();
      }
    }
    initMetadataForClass($, 'DefaultClientWebSocketSession', VOID, VOID, [WebSocketSession(), DefaultWebSocketSession()], [1, 0]);
    DefaultClientWebSocketSessionClass = $;
  }
  return DefaultClientWebSocketSessionClass;
}
var DelegatingClientWebSocketSessionClass;
function DelegatingClientWebSocketSession() {
  if (DelegatingClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, session) {
        this.i5t_1 = session;
        this.j5t_1 = call;
      }
      *r5b(frame, $completion) {
        yield* this.i5t_1.r5b(frame, $completion);
        return Unit_instance;
      }
      *k4k($completion) {
        yield* this.i5t_1.k4k($completion);
        return Unit_instance;
      }
      n5b(_set____db54di) {
        this.i5t_1.n5b(_set____db54di);
      }
      o5b() {
        return this.i5t_1.o5b();
      }
      p5b() {
        return this.i5t_1.p5b();
      }
      q5b() {
        return this.i5t_1.q5b();
      }
      bw() {
        return this.i5t_1.bw();
      }
    }
    initMetadataForClass($, 'DelegatingClientWebSocketSession', VOID, VOID, [WebSocketSession()], [1, 0]);
    DelegatingClientWebSocketSessionClass = $;
  }
  return DelegatingClientWebSocketSessionClass;
}
//region block: exports
export {
  DefaultClientWebSocketSession as DefaultClientWebSocketSession1n8ok3lng45wy,
  DelegatingClientWebSocketSession as DelegatingClientWebSocketSessiono1sywc6weckz,
};
//endregion

//# sourceMappingURL=ClientSessions.mjs.map
